export enum USER_TYPES {
  ATHLETE = "athlete",
  COACH = "coach",
  ADMINISTRATOR = "administrator",
}

export enum USER_STATES{
  ACTIVE = "active",
  INACTIVE = "inactive",
}
